export const defaultError: AppError = {
  code: 'callback.error',
  title: 'Sorry, something went wrong',
  body: "We've had a technical problem, please try again later.",
  ctaText: 'Back to previous page',
}

export const resetPasswordLinkUsedError: AppError = {
  code: 'reset_password.link_used.error',
  title: 'This link has already been used',
  body: 'Please request another link.',
  ctaText: 'Request another link',
}

export const passwordlessLinkUsedError: AppError = {
  code: 'passwordless.link_used.error',
  title: 'This sign-in link has already been used',
  body: 'Please request another link.',
  ctaText: 'Request another link',
}

export const resetPasswordLinkExpiredError: AppError = {
  code: 'reset_password.link_expired.error',
  title: 'This link has expired',
  ctaText: 'Go to homepage',
}

export const passwordlessLinkExpiredError: AppError = {
  code: 'passwordless.link_expired.error',
  title: 'This link has expired',
  ctaText: 'Go to homepage',
}

const errors: AppError[] = [
  resetPasswordLinkUsedError,
  resetPasswordLinkExpiredError,
  passwordlessLinkUsedError,
  passwordlessLinkExpiredError,
]

export default errors
